var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100 root" },
    [
      _c("app-breadcrumb", { attrs: { state: _vm.state } }),
      _c(
        "w-container",
        [
          _c("app-properties", { attrs: { state: _vm.state } }),
          _c("app-table", { attrs: { state: _vm.state } }),
          _vm.showSaleRecovery
            ? _c("app-recovery-info", { attrs: { state: _vm.state } })
            : _vm._e(),
          _c("app-totals", {
            attrs: {
              "edit-row": _vm.state.productEditRowState,
              "selected-row": _vm.state.selectedRow,
              totalable: _vm.state.sale,
              "toggle-profit": _vm.state.profitVisible,
              "toggle-stock-info": _vm.state.stockInfoVisible,
            },
          }),
        ],
        1
      ),
      _vm.state.saveModalOpen
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.state.saveModalOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.state, "saveModalOpen", $$v)
                },
                expression: "state.saveModalOpen",
              },
            },
            [_c("app-save-modal", { attrs: { state: _vm.state } })],
            1
          )
        : _vm._e(),
      _vm.state.ticketRefundModalOpen
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.state.ticketRefundModalOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.state, "ticketRefundModalOpen", $$v)
                },
                expression: "state.ticketRefundModalOpen",
              },
            },
            [
              _c("app-ticket-refund-modal", {
                attrs: { state: _vm.state },
                on: {
                  update: function ($event) {
                    return _vm.saleComplete()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.state.loyalty.modalOpen
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.state.loyalty.modalOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.state.loyalty, "modalOpen", $$v)
                },
                expression: "state.loyalty.modalOpen",
              },
            },
            [_c("app-loyalty-redeem-modal", { attrs: { state: _vm.state } })],
            1
          )
        : _vm._e(),
      _vm.state.sendModalOpen
        ? _c("app-send-modal", {
            attrs: {
              sale: _vm.state.sale,
              "extra-print-options": _vm.sendWithExtraPrintOptions,
            },
            on: {
              close: function ($event) {
                _vm.state.sendModalOpen = false
              },
              sent: function ($event) {
                return _vm.saleComplete()
              },
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.state.bankEditOpen,
            callback: function ($$v) {
              _vm.$set(_vm.state, "bankEditOpen", $$v)
            },
            expression: "state.bankEditOpen",
          },
        },
        [
          _c("app-bank-edit", {
            attrs: { sale: _vm.state.sale },
            on: {
              cancel: function ($event) {
                ;(_vm.state.bankEditOpen = false), _vm.saleComplete()
              },
              update: function ($event) {
                return _vm.saleComplete()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.state.lastPurchaseModalOpen,
            callback: function ($$v) {
              _vm.$set(_vm.state, "lastPurchaseModalOpen", $$v)
            },
            expression: "state.lastPurchaseModalOpen",
          },
        },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(
                    " " + _vm._s(_vm.$ct("components.sales.last-purchases"))
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.state.lastPurchaseModalOpen = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c("app-sale-row-search-browse", {
                staticClass: "modal-content",
                attrs: {
                  "book-year-select": true,
                  view: _vm.saleRowView,
                  "clear-view-settings-filters": "",
                  "allow-view-button": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.state.documentsModal,
            callback: function ($$v) {
              _vm.$set(_vm.state, "documentsModal", $$v)
            },
            expression: "state.documentsModal",
          },
        },
        [
          _c("app-sale-edit-aws-documents", {
            attrs: { sale: _vm.state.sale },
            on: {
              close: function ($event) {
                _vm.state.documentsModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100 preview",
          attrs: { "full-height": "", "escape-close": "" },
          model: {
            value: _vm.state.previewModal,
            callback: function ($$v) {
              _vm.$set(_vm.state, "previewModal", $$v)
            },
            expression: "state.previewModal",
          },
        },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("components.sales.preview"))),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.state.previewModal = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c("app-sale-pdf-preview", {
                attrs: { layout: _vm.layout, sale: _vm.state.sale, load: true },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }